<template>
  <div>
    <h1 class="zoombies-font">THE HEARTBEAT OF THE WORLD</h1>
    <p>Track all the important metrics you require to be a successful merchant in the Zoombies World systems</p>

    <h2 class="zoombies-font header-font">Zoom Mint-Burn Daily</h2>
    <apexchart class="chart-style" type="line" :options="chartOptions" :series="chartSeries"></apexchart>

  </div>
</template>

<script>
const statsBaseUrl = "https://zoombies.world/services/endpoints";

import { BCard, BTabs, BTab } from "bootstrap-vue";
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
    Vue.component('Apexchart', VueApexCharts);
import { mapGetters } from "vuex";
import { ethers } from "ethers";

const rarityNames = {
  1: "Diamond",
  2: "Platinum",
  3: "Epic",
  4: "Rare",
  5: "Uncommon",
  6: "Common",
};

const colors = [
  "#FFFFFF",
  "#D3D3D3",
  "#5745E5",
  "#CA3C2C",
  "#2BA4FA",
  "#545161",
];

export default {
  name: "DataIndicators",
  components: {

  },
  data() {
    return {
      chainId: 1287,
      chartSeries: [
                    {
                        name: "Total Zoom",
                        data: [],
                    },
                ],
      chartOptions: {
                    chart: {
                        height: 150,
                        type: "line",
                        stacked: false,
                        zoom: {
                            enabled: false,
                        },
                        toolbar: {
                            show: false,
                        }
                    },
                    tooltip: {
                        shared: true,
                        followCursor: true,
                        fillSeriesColor: true,
                        x: {
                            show: true,
                        },
                        style: {
                            fontFamily: "Truculenta, sans-serif",
                            color: "#000000",
                            fontSize: "18px",
                            cssClass: "apexcharts-tooltip",
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: "smooth",
                        width: [4, 4],
                    },
                    markers: {
                      show: true,
                      size: 3,
                      strokeWidth: 2,
                      strokeColors: "#fff",
                      hover: {
                        sizeOffset: 6,
                      },
                      colors: ["#FF19B1", "#FF19B1"],
                    },
                    colors: ["#FF19B1"],
                    xaxis: {
                        //categories are defined in chartSeries
                        type: "datetime",
                        labels: {
                            style: {
                                colors: "#FFFFFF",
                            }
                        }
                    },
                    yaxis: [
                        {
                          type: "numeric",
                          axisTicks: {
                              show: true,
                          },
                          axisBorder: {
                              show: true,
                              color: "#FF19B1",
                          },
                          title: {
                              text: "Net Daily Zoom Production",
                              style: {
                                fontSize: "18px",
                                color: "#ff19b1",
                              },
                          },
                          labels: {
                              style: {
                                fontSize: "14px",
                                colors: "#05e1ff",
                              },
                              formatter: function (val) {
                                return parseInt(val).toLocaleString();
                              },
                          }
                        },
                    ],
                    legend: {
                        labels: {
                        colors: "#FFFFFF",
                        },
                    },
                },
    };
  },
  computed: {
    ...mapGetters({
      getReadOnlyZoombiesContract: "blockChain/getReadOnlyZoombiesContract",
    }),
  },
  mounted() {
    this.querySubGraph();
  },
  methods: {
    querySubGraph: async function () {
        //Set the chainId
          if (
            window.location.pathname.includes("/moonbeam", 0)
          ) {
            this.chainId = 1284;
          }

        const query = `
            query{
              zoomInflations(last:100,filter:{
                network : {
                  equalTo : ${this.chainId}
                }
              }){
                nodes{
                  id
		              total
                }
              }
            }
        `;
        const graphEndPoint = "https://cryptoz.cards:3000"

        try {
          const result = await fetch(
            graphEndPoint,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body:JSON.stringify({
                query
                }),
            }
          );
          const res = await result.json();

          // split x and y values
          let newData = [];

          res.data.zoomInflations.nodes.forEach((node) => {
            newData.push({
              x: parseInt(node.id),
              y: ethers.utils.formatEther(node.total),
            })
          });

          this.chartSeries = [
                    {
                        name: "Net Zoom",
                        data: newData,
                    },
                ]


        } catch (err){
          console.log("Error from Data Indicators Dashboard Query: ", err);
          alert("Error from Data Indicators Dashboard Query, Please report to Zoombies Team");
        }
      },
  },
};
</script>

<style scoped lang="scss">

.zoombies-font {
  font-family: "Truculenta", sans-serif;
  font-weight: 700;
}

.header-font{

  color: #05e1ff;
}


.apexcharts-tooltip {
  background-color: #1c1f50;
  border: 4px solid red;
}
.chart-style {
  width: 800px;
}

@media screen and (max-width: 820px) {
  .chart-style {
    width: 90%;
  }
}


</style>
